import {nonce, key} from "./constants";
//@ts-ignore
import sha256 from 'crypto-js/sha256';
//@ts-ignore
import hmacSHA512 from 'crypto-js/hmac-sha512';
//@ts-ignore
import Base64 from 'crypto-js/enc-base64';

export function getCredentials (credentials: {username: string, password: string}) {
    const username = credentials.username;
    const hashDigest = sha256(nonce + credentials.password);
    const password = Base64.stringify(hmacSHA512(hashDigest, key));
    return {username, password};
}